import DirectHit from "@/assets/images/DirectHit.gif";
import Rocket from "@/assets/images/Rocket.gif";

export const SettingTabs = [
  // { key: "billings_and_plans", title: "Billings and Plans" },
  // { key: "campaign_settings", title: "Campaign Settings" },
  // { key: "usage", title: "Usage" },
  { key: "integrations", title: "Integrations" },
  { key: "deliverability", title: "Deliverability" },
  { key: "company_profile", title: "Company Profile" },
  { key: "voice_ai", title: "Voice Calling", adminOnly: true },
  { key: "api_key", title: "Api Key", adminOnly: true },
];

export const PlansDetails = [
  {
    id: 1,
    price: 1,
    img: DirectHit,
    currency: "$",
    per: "prospect",
    description:
      "A prospect is a persona with unique email you wish to target with omni-channel personalised outreach.",
    whatsIncluded: [
      { id: 1, title: "Email Personalization" },
      { id: 2, title: "Bulk Emailing" },
      { id: 3, title: "Buyer Intent Identification" },
      { id: 4, title: "Account Based Acquisition" },
      { id: 5, title: "Omni-channel Targeting" },
    ],
  },
  {
    id: 2,
    price: 5,
    img: Rocket,
    currency: "$",
    per: "account",
    description:
      "An account is a company to nurture, manage deals, and conversations. Hot prospects can be marked as accounts, grouping all prospects from the same company.",
    billed: "*Billed Monthly",
    whatsIncluded: [
      { id: 1, title: "Email Personalization" },
      { id: 2, title: "Bulk Emailing" },
      { id: 3, title: "Buyer Intent Identification" },
      { id: 4, title: "Account Based Acquisition" },
      { id: 5, title: "Omni-channel Targeting" },
      { id: 6, title: "Omni-channel Targeting 2" },
    ],
  },
];

export const UsageData = [
  { id: 1, title: "Conacts Analysed", value: 4, total: 30 },
  { id: 2, title: "Ai Credits", value: 0, total: 30 },
  { id: 3, title: "Email Credits", value: 10, total: 32 },
];

export function computeEmailLimitSplit(dailyEmailLimit) {
  const desl = Number(dailyEmailLimit);
  if (!Number.isFinite(desl) || desl < 0) {
    return { newContactEmailLimit: 0, followupEmailLimit: 0 };
  }
  const newContactEmailLimit = Math.floor(desl * 0.5);
  const followupEmailLimit = desl - newContactEmailLimit;
  return { newContactEmailLimit, followupEmailLimit };
}

export function buildFormDataFromSettings(s) {
  const defaults = {
    dailyEmailLimit: 50,
    newContactEmailLimit: 25,
    followupEmailLimit: 25,
    emailWarmupEnabled: false,
    linkedinConnectLimit: 20,
    linkedinMessageLimit: 40,
    linkedinProfileViewLimit: 30,
    linkedinWarmupEnabled: false,
    emailGapMinutes: 2,
    linkedinGapMinutes: 3,
    campaignContactsPerDayLimit: 15,
    randomizeSendTimes: true,
  };

  if (!s) {
    const split = computeEmailLimitSplit(defaults.dailyEmailLimit);
    return {
      ...defaults,
      newContactEmailLimit: split.newContactEmailLimit,
      followupEmailLimit: split.followupEmailLimit,
    };
  }

  const dailyEmailLimit = s?.dailyEmailLimit ?? defaults.dailyEmailLimit;
  const split = computeEmailLimitSplit(dailyEmailLimit);

  return {
    dailyEmailLimit,
    newContactEmailLimit: split.newContactEmailLimit,
    followupEmailLimit: split.followupEmailLimit,
    emailWarmupEnabled: s?.emailWarmupEnabled ?? defaults.emailWarmupEnabled,
    linkedinConnectLimit:
      s?.linkedinConnectLimit ?? defaults.linkedinConnectLimit,
    linkedinMessageLimit:
      s?.linkedinMessageLimit ?? defaults.linkedinMessageLimit,
    linkedinProfileViewLimit:
      s?.linkedinProfileViewLimit ?? defaults.linkedinProfileViewLimit,
    linkedinWarmupEnabled:
      s?.linkedinWarmupEnabled ?? defaults.linkedinWarmupEnabled,
    emailGapMinutes: s?.emailGapMinutes ?? defaults.emailGapMinutes,
    linkedinGapMinutes: s?.linkedinGapMinutes ?? defaults.linkedinGapMinutes,
    campaignContactsPerDayLimit:
      s?.campaignContactsPerDayLimit ?? defaults.campaignContactsPerDayLimit,
    randomizeSendTimes: s?.randomizeSendTimes ?? defaults.randomizeSendTimes,
  };
}

export const deliverabilityConfig = [
  {
    sectionTitle: "Email Sending Limits",
    sectionDescription:
      "Set daily sending limits to maintain good email deliverability and avoid spam detection.",
    fields: [
      {
        key: "dailyEmailLimit",
        label: "Daily Email Sending Limit",
        helperText: "(Recommended 20-25 per day)",
        suffix: "/ Day",
        options: [
          5, 10, 15, 20, 25, 30, 35, 40, 45, 50
        ],
      },
      {
        key: "newContactEmailLimit",
        label: "New Contact Email Limit",
        suffix: "/ Day",
        type: "text",
        disabled: true,
      },
      {
        key: "followupEmailLimit",
        label: "Follow Up Email Limit",
        suffix: "/ Day",
        type: "text",
        disabled: true,
      },
      {
        key: "emailWarmupEnabled",
        label: "Email Warm-up mode",
        helperText:
          "Gradually increases sending limits for new accounts to protect deliverability. Starts with a low daily cap (e.g., 10 emails/day) and scales up ~10% daily, up to a max of 50/day.",
        type: "toggle",
      },
    ],
  },
  {
    sectionTitle: "LinkedIn Activity Limits",
    sectionDescription:
      "Control daily LinkedIn actions to avoid account restrictions and automation detection.",
    fields: [
      {
        key: "linkedinConnectLimit",
        label: "Connection requests per day",
        suffix: "/ Day",
        options: [10, 15, 20],
      },
      {
        key: "linkedinMessageLimit",
        label: "LinkedIn messages per day",
        suffix: "/ Day",
        options: [
          10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
          95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160,
          165, 170, 175, 180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230,
          235, 240, 245, 250, 255, 260, 265, 270, 275, 280, 285, 290, 295, 300,
        ],
      },
      {
        key: "linkedinProfileViewLimit",
        label: "Profile views per day",
        disabled: true,
        helperText: "Profile-view campaign steps are not currently supported.",
        suffix: "/ Day",
        options: [
          10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
          95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160,
          165, 170, 175, 180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230,
          235, 240, 245, 250, 255, 260, 265, 270, 275, 280, 285, 290, 295, 300,
        ],
      },
      {
        key: "linkedinWarmupEnabled",
        label: "LinkedIn Warm-up mode",
        helperText:
          "Gradually increase LinkedIn activity limits for new accounts to avoid restrictions. Example: Week 1: 10 actions/day, Week 2: 20 actions/day",
        type: "toggle",
      },
    ],
  },
  {
    sectionTitle: "Sending Behaviour",
    sectionDescription:
      "Control the pacing of automated outreach so messages appear more natural.",
    fields: [
      {
        key: "emailGapMinutes",
        label: "Sending gap between emails",
        suffix: "Minutes",
        options: [
          1, 2, 3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
          80, 85, 90, 95, 100,
        ],
      },
      {
        key: "linkedinGapMinutes",
        label: "Sending gap between LinkedIn messages",
        suffix: "Minutes",
        options: [
          1, 2, 3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
          80, 85, 90, 95, 100,
        ],
      },
      {
        key: "campaignContactsPerDayLimit",
        label: "Campaign contacts per day limit",
        suffix: "Contacts",
        options: [10, 15],
        disabled: true,
      },
      {
        key: "randomizeSendTimes",
        label: "Randomize send time to mimic human behaviour",
        helperText:
          "We add a small random delay to scheduled email and LinkedIn actions so they don’t all go out at the exact same second, which makes sending patterns look more natural.",
        type: "toggle",
      },
    ],
  },
];
